import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;

  .mantine-SegmentedControl-label {
    min-width: 40px;
  }
`;
